/**
 * SELLY Color Sync
 *
 * Problem: SELLY's adck() reads color from .swatch-variant-name:first which is
 * a hidden element that never updates. The visible .swatch-variant-name (index 1)
 * updates correctly via Swatch King. This script syncs hidden[0] to match visible
 * so adck() filters recommendation cards by the correct color.
 *
 * How it works:
 * 1. On every swatch click (300ms delay) — sync hidden element before adck() runs (500ms)
 * 2. Exposes window.SellyColorSync.sync() for manual trigger (used by linked-product-swap.js)
 *
 * Debug: all logs prefixed [SellySync]
 */
(function () {
  "use strict";

  var DEBUG = window.__linkedSwapDebug || false;
  var _syncing = false;

  /**
   * Sync hidden .swatch-variant-name:first to match visible one,
   * then fire SELLY's delegated click handler so adck() runs.
   */
  function sync() {
    if (_syncing || typeof jQuery === "undefined") return;
    _syncing = true;

    setTimeout(function () {
      var visibleName = jQuery(".swatch-variant-name:visible")
        .first()
        .text()
        .replace(/^[\s:]+/, "")
        .trim();
      var hiddenName = jQuery(".swatch-variant-name").first().text().trim();

      DEBUG && console.log("[SellySync] visible:", visibleName, "| hidden[0]:", hiddenName);

      if (!visibleName) {
        _syncing = false;
        return;
      }

      if (visibleName === hiddenName) {
        DEBUG && console.log("[SellySync] already in sync, triggering adck only");
      } else {
        jQuery(".swatch-variant-name").first().text(visibleName);
        DEBUG && console.log("[SellySync] updated hidden[0] →", visibleName);
      }

      // Fire SELLY's jQuery delegated handler: jQuery(document).on('click', '.swatch-view-item', fn)
      // Using jQuery.Event on document avoids native click (no Swatch King / linked-swap side effects)
      var swatchEl = jQuery(".swatch-view-item").get(0);
      if (swatchEl) {
        jQuery(document).trigger(jQuery.Event("click", { target: swatchEl }));
        DEBUG && console.log("[SellySync] triggered adck via jQuery event");
      }

      setTimeout(function () {
        _syncing = false;
      }, 1000);
    }, 600);
  }

  /**
   * Quick sync — just update hidden element text, no adck trigger.
   * Used before SELLY's own adck() runs on native swatch click (300ms < 500ms).
   */
  function quickSync() {
    if (typeof jQuery === "undefined") return;
    var visibleName = jQuery(".swatch-variant-name:visible")
      .first()
      .text()
      .replace(/^[\s:]+/, "")
      .trim();
    if (visibleName) {
      jQuery(".swatch-variant-name").first().text(visibleName);
      DEBUG && console.log("[SellySync:quick] hidden[0] →", visibleName);
    }
  }

  // ---- Global swatch click listener ----
  // Sync hidden element on every swatch click, before SELLY's adck() (500ms)
  document.addEventListener("click", function (e) {
    if (_syncing) return;
    if (!e.target.closest(".swatch-view-item")) return;
    setTimeout(quickSync, 300);
  });

  // ---- Expose API ----
  window.SellyColorSync = {
    sync: sync,
    quickSync: quickSync,
    isSyncing: function () { return _syncing; }
  };

  DEBUG && console.log("[SellySync] loaded");
})();
